import { type ApolloClient, gql } from '@apollo/client/core';
import type { Query } from '../../../generated/api.graphql';
import * as Report from './Report';

export const LOOKER_REPORTS_QUERY = gql`
  query LookerReports {
    lookerReports {
      name
      reportId
      pageId
    }
  }
`;

export const LOOKER_REPORT_LINK_QUERY = gql`
  query LookerReportLink($reportId: String!, $pageId: String) {
    lookerReportLink(reportId: $reportId, pageId: $pageId)
  }
`;

export const fetchAllReports = async (client: ApolloClient<Query>): Promise<Report.Report[]> => {
  const { data } = await client.query({ query: LOOKER_REPORTS_QUERY, fetchPolicy: 'network-only' });

  return (data.lookerReports ?? []).map(Report.fromGql);
};

export const fetchSelectedReportLink = async (client: ApolloClient<Query>, reportId: string, pageId: string | null = null): Promise<string> => {
  const { data } = await client.query({
    query: LOOKER_REPORT_LINK_QUERY,
    variables: { reportId, pageId },
    fetchPolicy: 'network-only',
  });

  if (!data.lookerReportLink) {
    throw new Error('Failed to fetch the report link.');
  }

  return data.lookerReportLink;
};
